// extracted by mini-css-extract-plugin
module.exports = {"inputDateRangePicker":"styles-module__inputDateRangePicker___ziFNR","bi":"styles-module__bi___3r9ml"};